var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgOverdue = function SvgOverdue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12c-.625-.625-1.25-1.25-1.5-2-1.5 1.5-3.695 5.703-1.5 10C5.823 18.714 5 16 5 14 5 9 8.923 3.78 10.963 2c.314 3.682 1.126 7.18 3.675 7.18C15.666 9.18 16.655 7.605 17 7c.104.31.249.686.414 1.113.631 1.632 1.553 4.016 1.553 6.421C18.967 18.5 17 19.5 15.5 20c0-.081.066-.294.161-.602.493-1.591 1.77-5.723-1.161-7.398l-.043.064c-.386.575-.975 1.454-1.457 1.936-.25-.75-.875-1.375-1.5-2zm-1 1.5c0 1 .884 2.607 2.067 3.029C13.5 17 14.5 15 14.5 15c.5 1 .5 1.5.5 2.5 0 1.5-1 3.5-3 3.5s-3-2-3-4c0-1.715.5-2.5 1.5-3.5z"
  })));
};

export default SvgOverdue;